<div
  #container
  [class]="`filter-button filter-button--${alignment()}`"
  [id]="id"
>
  <procure-button-group>
    <button
      class="filter-button__toggle"
      procure-button
      suffix="arrow_drop_down"
      filter
      wide
      variant="flat"
      [matTooltip]="tooltip() ? (remainder() ?? '') : ''"
      [color]="hasValue() ? activeColor() : 'grey'"
      (click)="toggleOverlay()"
    >
      <span class="filter-button__label">
        @if (hasValue()) {
          <span>
            <b>{{ `${label()}:` }}</b>
          </span>
        } @else {
          {{ label() }}
        }
      </span>
      @if (!tooltip()) {
        <span class="filter-button__remainder">
          @if (remainder(); as remainder) {
            ({{ remainder }})
          }
        </span>
      }
    </button>
    @if (hasValue()) {
      <button
        class="filter-button__clear"
        procure-button
        filter
        variant="flat"
        [color]="activeColor()"
        (click)="reset()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </procure-button-group>
  @if (isOpened()) {
    <div
      #overlay
      class="filter-button__overlay mat-elevation-z8 overlay"
    >
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="stroked"
          (click)="reset()"
        >
          Reset
        </button>
      </div>
      <div formRow>
        <procure-show-field
          [label]="label()"
          [hint]="hint()"
        >
          @if (hasValue()) {
            @if (decimal()) {
              {{ `${(min() | decimal)} - ${(max() | decimal)}` }}
            } @else {
              {{ `${min()} - ${max()}` }}
            }
          } @else {
            -
          }
        </procure-show-field>
      </div>
      <ng-content />
      <div formRow>
        <procure-card flat>
          <div formRow>
            <procure-input-text
              label="Min"
              numericInput
              [control]="group().controls.min"
            />
          </div>
          <div formRow>
            <procure-input-text
              label="Max"
              numericInput
              [control]="group().controls.max"
            />
          </div>
          <div formRow>
            <ng-container
              #outlet
              [ngTemplateOutlet]="inputRange"
            />
          </div>
        </procure-card>
      </div>
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="flat"
          (click)="toggleOverlay()"
        >
          Close
        </button>
      </div>
    </div>
  }
</div>
<ng-template #inputRange>
  <procure-input-range
    [label]="label()"
    [min]="minValue()"
    [max]="maxValue()"
    [group]="group()"
  />
</ng-template>
